export default function reportPackageConfigReportParamDirective() {
  return {
    template: require('./report-package-config-report-param.html'),
    controller: 'PRReportPackageConfigReportParamController',
    controllerAs: 'prReportPackageConfigReportParamVM',
    bindToController: true,
    replace: true,
    scope: {
      reportPackageId: '@',
      reportPackageReportId: '@',
      reportParameter: '=',
    },
  };
}
